import { render, staticRenderFns } from "./MovieReview.vue?vue&type=template&id=28379eee&"
import script from "./MovieReview.vue?vue&type=script&lang=js&"
export * from "./MovieReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports